import type { AdminSurface } from '@/lib/guards';

import type { RoleType } from './roles';

const WORKSPACE_ALLOWED: readonly RoleType[] = [
  'ba_super_admin',
  'ba_admin',
  'chief_psychologist',
  'psychologist',
];

/**
 * BE gates `POST /clients/shadow` with
 * `requireRole('ba_super_admin', 'ba_admin', 'chief_psychologist', 'psychologist')`
 * (clientRoute.ts:90-98). `super_admin` also passes via requireRole's
 * super_admin bypass and creates from the platform surface, where the BA is
 * derived from the organization server-side. Mirror that split on the FE:
 * the workspace and clinical surfaces show the quick-create affordance to the
 * four roles the route names, the platform surface to super_admin only, so no
 * role sees a button the BE would reject.
 */
export function canCreateDormantClient({
  role,
  surface,
}: {
  role: RoleType | null;
  surface: AdminSurface;
}): boolean {
  if (role === null) return false;
  if (surface === 'platform') return role === 'super_admin';
  return WORKSPACE_ALLOWED.includes(role);
}
